import React from "react";
import illustration from "../../assets/images/freePlanImage.svg";
import { DEFAULT_FONT_FAMILY } from "../../config/fontConfig";
const FreePlanCard: React.FC = () => {
  return (
    <div className="bg-transparent flex justify-center items-center p-4">
      <div className="text-center w-full">
        {/* Illustration from external image */}
        <div className="flex justify-center mb-4">
          <img
            src={illustration}
            alt="Free Plan Illustration"
            className="w-40 h-auto 3xl:w-56 4xl:w-72"
          />
        </div>

        {/* Title */}
        <h2
          className="text-[20px] 3xl:text-[22px] 4xl:text-[26px] font-semibold text-[#2A3547]"
          style={{ fontFamily: DEFAULT_FONT_FAMILY }}
        >
          You're on the free plan – enjoy unlimited access for now!
        </h2>

        {/* Description */}
        <p
          className="text-sm 3xl:text-[16px] 4xl:text-[20px] text-[#2A3547] mt-2 4xl:mt-3"
          style={{ fontFamily: DEFAULT_FONT_FAMILY }}
        >
          You can use all features at no cost during our early access. <br />
          We might add paid plans later, but there will always be a free option.
        </p>
      </div>
    </div>
  );
};

export default FreePlanCard;
